export default {
  CASH: { name: "Cash", value: "gotówka" },
  BANK_TRANSFER: { name: "Bank transfer", value: "przelew" },
  ONLINE: { name: "Online payment", value: "płatność_online" },
};
